import React,{Fragment} from "react";
import TransferOne from "./TransferOne";
import "@ant-design/compatible/assets/index.css";
import { Button,Collapse} from "antd";

const { Panel } = Collapse;

class HmgRoleMapping extends React.Component {
  render() {
    const {onSubmit,initialValue,rolesGetData,updateMappedRoles,activeSubmit} = this.props;
    
    return (
      <Fragment>
        <Collapse defaultActiveKey={["2_1"]} expandIconPosition="end">
          <Panel
           header="HMG Hotel Roles Mapping"
            key="2_1"
          >
            <TransferOne
              roleGetData={rolesGetData}
              initialValue={initialValue} 
              updateMappedRoles={updateMappedRoles}
            />
            <div style={{textAlign: 'center',marginTop: 30}}>
              <div wrapperCol={{ span: 12, offset:6 }}>
                <Button type="primary" onClick={onSubmit} disabled={!activeSubmit}>
                  Update
                </Button>
              </div>
            </div>           
          </Panel>
        </Collapse>
      </Fragment>
    );
  }
}
const WrappedApp =HmgRoleMapping;
export default WrappedApp;
